import React from 'react';
import { useNavigate } from 'react-router';
import { ContainerLayout } from 'components/ContainerLayout/ContainerLayout';
import { useLoggedInUser } from 'features/auth/hooks/useAuthData';
import { useStatsDownload } from 'hooks/useStatsDownload';
import { useGetStatsQuery } from 'services/statsService';
import { formatLocalDateString, parseLocalDateString } from 'utils/dateUtils';
import { DAYS_IN_WEEK } from 'components/ProgressTab/Widgets/StepCountWidget/StepCountWidget';
import { StepCountDetailPageView } from './StepCountDetailPageView';

const shiftDays = (date: string, days: number) => {
  const shifted = parseLocalDateString(date);
  shifted.setDate(shifted.getDate() + days);
  return formatLocalDateString(shifted);
};

export const StepCountDetailPage = () => {
  const navigate = useNavigate();
  const user = useLoggedInUser();
  const [today] = React.useState(() => formatLocalDateString(new Date()));
  // 0 = the week ending today.
  const [weeksBack, setWeeksBack] = React.useState(0);
  const endDate = shiftDays(today, -DAYS_IN_WEEK * weeksBack);
  const startDate = shiftDays(endDate, -(DAYS_IN_WEEK - 1));
  // Only the calendar day matters, whether or not enrollment_date carries a time.
  const enrollmentDate = user?.enrollment_date?.slice(0, 10);
  // currentData (unlike data) is empty while a new week loads, so the old week isn't shown under the new label.
  const { currentData, isFetching, isError } = useGetStatsQuery({ startDate, endDate });
  const { download, isDownloading } = useStatsDownload('physical_activity', startDate, endDate);

  return (
    <ContainerLayout>
      <StepCountDetailPageView
        physicalActivityStats={currentData?.physical_activity_stats ?? []}
        endDate={endDate}
        onPrevious={() => setWeeksBack((current) => current + 1)}
        onNext={() => setWeeksBack((current) => current - 1)}
        // Going back once more would show a week that ends before enrollment.
        disablePrevious={!enrollmentDate || startDate <= enrollmentDate}
        disableNext={weeksBack === 0}
        isLoading={isFetching && currentData == null}
        isError={isError && currentData == null}
        onBack={() => navigate(-1)}
        onDownload={download}
        isDownloading={isDownloading}
      />
    </ContainerLayout>
  );
};
